import { connectorEventMappings } from "../../apiService/blustreamApi";

export const getEventMappings = () => connectorEventMappings.list();

// The server has no enabled-only route for event mappings (unlike attribute
// mappings' equivalent), so this fetches the full page and filters client-side.
export const getEnabledEventMappings = async () => {
  const res = await connectorEventMappings.list();
  const content = Array.isArray(res?.content) ? res.content : [];
  return content.filter((mapping) => mapping.enabled);
};

export const getEventMapping = (id) => connectorEventMappings.get(id);

export const createEventMapping = (body) => connectorEventMappings.create(body);

export const updateEventMapping = (id, body) => connectorEventMappings.update(id, body);

export const deleteEventMapping = (id) => connectorEventMappings.remove(id);
